module.exports = __webpack_public_path__ + "media/images/users/user-7-1c6045a45827ed7771662288dac7bbb8.jpg";